import { render, staticRenderFns } from "./Model19.vue?vue&type=template&id=70eb9b5c&scoped=true"
import script from "./Model19.vue?vue&type=script&lang=js"
export * from "./Model19.vue?vue&type=script&lang=js"
import style0 from "./Model19.vue?vue&type=style&index=0&id=70eb9b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb9b5c",
  null
  
)

export default component.exports